(function () {
	'use strict';
	$(document).ready(function () {

		function b64DecodeUnicode(str) {
			return decodeURIComponent(
				Array.prototype.map
				.call(atob(str), function (c) {
					return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join("")
			);
		}

		function getOfferList(limit, phrase, location) {
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				method: "post",
				timeout: 10000,
				data: {
					action: "get_jobs",
					limit: limit,
					phrase: phrase,
					location: location,
				},
				success: function (data) {
					try {
						JSON.parse(data);
					} catch (e) {
						$('#jobs-api-wrapper').text('Error. Try again.');
						return;
					}

					let jobOffers = JSON.parse(data);

					if (jobOffers['count'] > 0) {
						let jobOffersHTML = '';
						jobOffersHTML = '<div class="row jobs-api-list">';
						jobOffers['items'].map(function (offer, index) {

							const location = jobOffers['FHLocations'].filter(loc => loc.GeographyNodeId === offer['PrimaryLocationId']);
							const locationName = location[0]['GeographyName'];

							let date = new Date(offer['CreationDate']);
							let offerFormattedDate = date.toLocaleDateString("en-US");

							if (index === 5) {
								jobOffersHTML += $('.js-jobs-api-item-special')[0].outerHTML;
							} else {
								jobOffersHTML += `
									<div class="col-12 col-lg-4">
										<div class="jobs-api-item jobs-api-item-normal" data-offer-id="${offer['RequisitionNumber']}" data-toggle="modal" data-target="#jobOfferModal">
											<div class="jobs-api-item-meta">
												<p class="title">${offer['Title']}</p>
												<div class="meta">
													<span class="locatiob">${locationName}</span>
													<span>&bull;</span>
													<span class="posted">Posted on ${offerFormattedDate}</span>
												</div>
											</div>`;

											if (offer['InternalShortDescription']) {
												jobOffersHTML += `
													<div class="jobs-api-item-desc">
														<p class="desc">${b64DecodeUnicode(offer['InternalShortDescription'])}</p>
													</div>
												`;
											}
								jobOffersHTML += `
										</div>
									</div>
								`;
							}
						});
						jobOffersHTML += '</div>';
						$('#jobs-api-wrapper').html(jobOffersHTML);
					} else {
						$('#jobs-api-wrapper').text('No results.');
					}
				},
				error: function () {
					$('#jobs-api-wrapper').text('Error. Try again.');
				},
				beforeSend: function () {
					$('#jobs-api-wrapper').html('<span class="loader"></span>');
				},
			});
		}

		if ( ($('.homepage').length) || ($('.subpage-jobs').length) ) {

			let limit = 100000;
			if (($('.homepage').length)) {
				limit = 6;
			}

			getOfferList(limit);

			$('form.job-search').on('submit', function(e) {
				let phrase = $('.job-search input[name=phrase]').val();
				let location = $('.job-search input[name=location]').val();

				getOfferList(limit, phrase, location);
				e.preventDefault();
			});

			$('.js-job-search-clear').on('click', function() {
				let phrase = $('.job-search input[name=phrase]').val('');
				let location = $('.job-search input[name=location]').val('');

				getOfferList(limit);
			});
		}


		function getOfferSingle(offerId) {
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				method: "post",
				timeout: 10000,
				data: {
					action: "get_jobs",
					offer_id: offerId,
				},
				success: function (data) {
					if (data === '0') {
						$('#job-offer-details').text('Error. Try again.');
						return;
					}

					try {
						JSON.parse(data);
					} catch (e) {
						$('#job-offer-details').text('Error. Try again.');
						return;
					}

					let jobOffer = JSON.parse(data);

					let jobOfferHTML = '';
					jobOfferHTML = '<div class="row no-gutters">';
						jobOfferHTML += `<div class="col-12">`;

						if (jobOffer['Title']) {
							jobOfferHTML += `		
								<p><strong>Job Title</strong></p>
								<h2>${jobOffer['Title']}</h2>
								<hr>
							`;
						}

						if (jobOffer['RequisitionNumber'] || jobOffer['FHOfferCategoryName'] || jobOffer['CreationDate'] || jobOffer['FullTimeOrPartTime'] || jobOffer['FHOfferLocationName']) {
							jobOfferHTML += `
								<div class="job-section">
									<p><strong>Job Info</strong></p>
							`;
						}

							if (jobOffer['RequisitionNumber']) {
								jobOfferHTML += `
									<div class="row">
										<div class="col-12 col-md-3"><p><strong>Identification</strong></p></div>
										<div class="col-12 col-md-3"><p>${jobOffer['RequisitionNumber']}</p></div>
									</div>
								`;
							}

							if (jobOffer['FHOfferCategoryName']) {
								jobOfferHTML += `
									<div class="row">
										<div class="col-12 col-md-3"><p><strong>Category</strong></p></div>
										<div class="col-12 col-md-3"><p>${jobOffer['FHOfferCategoryName']}</p></div>
									</div>
								`;
							}

							if (jobOffer['CreationDate']) {
								let date = new Date(jobOffer['CreationDate']);
								let offerFormattedDate = date.toLocaleDateString("en-US");
								jobOfferHTML += `
									<div class="row">
										<div class="col-12 col-md-3"><p><strong>Posting Date</strong></p></div>
										<div class="col-12 col-md-3"><p>${offerFormattedDate}</p></div>
									</div>
								`;
							}

							if (jobOffer['FullTimeOrPartTime']) {
								jobOfferHTML += `
									<div class="row">
										<div class="col-12 col-md-3"><p><strong>Schedule</strong></p></div>
										<div class="col-12 col-md-3"><p>${jobOffer['FullTimeOrPartTime'] === 'FULL_TIME' ? 'Full time' : 'Part time'}</p></div>
									</div>
								`;
							}

							if (jobOffer['FHOfferLocationName']) {
								jobOfferHTML += `
									<div class="row">
										<div class="col-12 col-md-3"><p><strong>Location</strong></p></div>
										<div class="col-12 col-md-3"><p>${jobOffer['FHOfferLocationName']}</p></div>
									</div>
								`;
							}

						if (jobOffer['RequisitionNumber'] || jobOffer['FHOfferCategoryName'] || jobOffer['CreationDate'] || jobOffer['FullTimeOrPartTime'] || jobOffer['FHOfferLocationName']) {
							jobOfferHTML += `</div>`;
						}

					if (jobOffer['ExternalDescription']) {
						jobOfferHTML += `
							<div class="job-section">	
								<p><strong>Job Description</strong></p>							
								<p>${b64DecodeUnicode(jobOffer['ExternalDescription'])}<p>								
							</div>`;
					}

					if (jobOffer['InternalRespHTML']) {
						jobOfferHTML += `
							<div class="job-section">
								<p><strong>Responsibilities</strong></p>
								<p>${b64DecodeUnicode(jobOffer['InternalRespHTML'])}</p>
							</div>`;
					}

					if (jobOffer['ExternalQualHTML']) {
						jobOfferHTML += `
							<div class="job-section">
								<p><strong>Qualifications</strong></p>
								<p>${b64DecodeUnicode(jobOffer['ExternalQualHTML'])}</p>
							</div>`;
					}

					if (jobOffer['InternalQualHTML']) {
						jobOfferHTML += `
							<div class="job-section">
								<p><strong>Skill Requirements</strong></p>
								<p>${b64DecodeUnicode(jobOffer['InternalQualHTML'])}</p>
							</div>`;
					}

					if (jobOffer['FHAboutUs']) {
						jobOfferHTML += `
							<div class="job-section">
								<p><strong>About Us</strong></p>
								${b64DecodeUnicode(jobOffer['FHAboutUs'])}
							</div>`;
					}

					if (jobOffer['FHAboutTheTeam']) {
						jobOfferHTML += `
							<div class="job-section">
								<p><strong>About The Team</strong></p>
								${b64DecodeUnicode(jobOffer['FHAboutTheTeam'])}
							</div>`;
					}

						jobOfferHTML += `
							<div class="job-section">
								<div class="gsap-from-bottom">
									<a href="${window.FH_CONFIG.jobsApiLink}/hcmUI/CandidateExperience/en/sites/CX_1/requisitions/preview/${jobOffer['RequisitionNumber']}/apply/email"
									   target="_blank"
									   class="btn btn-link btn-brand"
									>Apply now</a>
								</div>
							</div>
							
							<div class="job-section">
								<div class="gsap-from-bottom">
									<a href="/jobs" target="_self" class="btn btn-link btn-brand">See more jobs</a>
								</div>
							</div>
						</div>
						`;
					jobOfferHTML += '</div>';

					$('#job-offer-details').html(jobOfferHTML);

				},
				error: function () {
					$('#job-offer-details').text('Error. Try again.');
				},
				beforeSend: function () {
					$('#job-offer-details').html('<span class="loader"></span>');
				},
			});
		}

		$('#jobOfferModal').on('show.bs.modal', function (e) {
			let offerId = $(e.relatedTarget).data('offer-id');
			getOfferSingle(offerId);
			$('.js-offer-link-copy').data('offer-link-id', offerId);

			$('.js-offer-link-copy').on('click', function() {
				let offerLinkId = $(this).data('offer-link-id');
				let offerLinkUrl = new URL(window.location.href) + 'job?offer=' + offerLinkId;
				navigator.clipboard.writeText(offerLinkUrl);
			});
		});

		if ($('.subpage-job').length) {
			let url = new URL(window.location.href);
			let params = new URLSearchParams(url.search);
			const offerId = parseInt(params.get('offer'));
			getOfferSingle(offerId);
		}

	});
}(jQuery));